import Box from "@mui/material/Box";
import Logger from "../../../services/Logger";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminGridService from "./AdminGridService";
import { getGridColumns } from "./getGridColumns";

export default function AdminGridList({ keyword, state, free, reload }) {
    const navigate = useNavigate();

    const [pageModel, setPageModel] = useState({ page: 0, pageSize: 15 });
    const [sort, setSort] = useState([{ field: "publishedAt", sort: "desc" }]);
    const [rowCount, setRowCount] = useState(0);
    const [rows, setRows] = useState([]);

    useEffect(() => {
        // Logger.log("uef in AdminHiddenWordList");

        AdminGridService.requestPuzzle(pageModel, sort, keyword, state, free, setRows, setRowCount);
    }, [pageModel, sort, keyword, state, free, reload]);

    const handleCell = (cell) => {
        // Logger.log(cell);
        if (cell.field == "title") {
            navigate(`/admin/puzzle/grid/detail/${cell.id}`);
        }
    };

    const handleSort = (model) => {
        setSort(model);
    };

    const handleSelectionModel = () => {
        // do something
    };

    return (
        <Box sx={{ flexGrow: 1, height: "calc(100vh - 200px)" }}>
            <DataGrid
                rows={rows}
                columns={getGridColumns()}
                rowCount={rowCount}
                pageSizeOptions={[15, 25, 30]}
                paginationMode="server"
                sortingMode="server"
                pagination={true}
                paginationModel={pageModel}
                onPaginationModelChange={(m) => setPageModel(m)}
                // checkboxSelection
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: false }}
                onCellClick={handleCell}
                onSortModelChange={handleSort}
                onSelectionModelChange={handleSelectionModel}
                columnVisibilityModel={{ id: false }}
                hideFooterSelectedRowCount
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            id: false,
                        },
                    },
                }}
                sx={{
                    "& .MuiDataGrid-cell:first-of-type:hover": {
                        cursor: "pointer",
                    },
                    height: "100%",
                }}
            />
        </Box>
    );
}

